import React from "react";

export const CartIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M3 4h2l2.2 10.2a1.6 1.6 0 0 0 1.6 1.3h7.7a1.6 1.6 0 0 0 1.6-1.2L20 7H6" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="9.5" cy="19" r="1.3" fill="currentColor" stroke="none" />
    <circle cx="16.5" cy="19" r="1.3" fill="currentColor" stroke="none" />
  </svg>
);

export const VideoIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
    <rect x="3" y="6" width="12" height="12" rx="2.5" />
    <path d="M15 10.5l5-2.6v8.2l-5-2.6z" strokeLinejoin="round" />
  </svg>
);

export const TicketIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M4 8.5A1.5 1.5 0 0 1 5.5 7h13A1.5 1.5 0 0 1 20 8.5v2a2 2 0 0 0 0 3.9v2A1.5 1.5 0 0 1 18.5 18h-13A1.5 1.5 0 0 1 4 16.5v-2a2 2 0 0 0 0-3.9z" strokeLinejoin="round" />
    <path d="M13 7.5v11" strokeDasharray="2 2.4" strokeLinecap="round" />
  </svg>
);

export const WebhookIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
    <circle cx="8" cy="7" r="2.6" />
    <circle cx="17" cy="12" r="2.6" />
    <circle cx="8" cy="17.5" r="2.6" />
    <path d="M9.6 9.2l5.2 2M15 14.3l-5.1 2M6.6 9.4l-.1 5.5" strokeLinecap="round" />
  </svg>
);

export const CloudIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M7.5 18h9a3.8 3.8 0 0 0 .4-7.6 5.2 5.2 0 0 0-9.9-1.2A3.9 3.9 0 0 0 7.5 18z" strokeLinejoin="round" />
  </svg>
);

export const NoteIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
    <rect x="4.5" y="3.5" width="15" height="17" rx="2.5" />
    <path d="M8.5 8.5h7M8.5 12h7M8.5 15.5h4" strokeLinecap="round" />
  </svg>
);

export const SyncIcon = () => (
  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M4.5 11a7.5 7.5 0 0 1 12.8-4.6L20 9" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M19.5 13a7.5 7.5 0 0 1-12.8 4.6L4 15" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M20 4.5V9h-4.5M4 19.5V15h4.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

// Brand marks for the calendar integrations. Drawn inline rather than pulled
// from a CDN so they render offline and inherit no external styling.

export const CalendlyLogo = () => (
  <svg viewBox="0 0 48 48" width="52" height="52" aria-hidden="true">
    <circle cx="24" cy="24" r="21" fill="#006BFF" />
    <path
      d="M31.5 17.8a10.2 10.2 0 1 0 0 12.4"
      fill="none"
      stroke="#fff"
      strokeWidth="4.6"
      strokeLinecap="round"
    />
  </svg>
);

export const GoogleCalendarLogo = () => (
  <svg viewBox="0 0 48 48" width="52" height="52" aria-hidden="true">
    <rect x="9" y="9" width="30" height="30" rx="4" fill="#fff" />
    <path d="M9 13a4 4 0 0 1 4-4h8v5H9z" fill="#4285F4" />
    <path d="M21 9h9v5h-9z" fill="#EA4335" />
    <path d="M30 9h5a4 4 0 0 1 4 4v1H30z" fill="#FBBC04" />
    <path d="M9 30h30v5a4 4 0 0 1-4 4H13a4 4 0 0 1-4-4z" fill="#34A853" />
    <rect
      x="9"
      y="9"
      width="30"
      height="30"
      rx="4"
      fill="none"
      stroke="#dadce0"
      strokeWidth="1.4"
    />
    <text
      x="24"
      y="28"
      textAnchor="middle"
      fontSize="13"
      fontWeight="700"
      fill="#4285F4"
      fontFamily="Inter, sans-serif"
    >
      31
    </text>
  </svg>
);

export const AppleCalendarLogo = () => (
  <svg viewBox="0 0 48 48" width="52" height="52" aria-hidden="true">
    <rect
      x="9"
      y="9"
      width="30"
      height="30"
      rx="6.5"
      fill="#fff"
      stroke="#e3e3e8"
      strokeWidth="1.4"
    />
    <text
      x="24"
      y="20"
      textAnchor="middle"
      fontSize="6.5"
      fontWeight="700"
      fill="#FF3B30"
      letterSpacing="0.4"
      fontFamily="Inter, sans-serif"
    >
      SUN
    </text>
    <text
      x="24"
      y="34"
      textAnchor="middle"
      fontSize="15"
      fontWeight="600"
      fill="#1d1d1f"
      fontFamily="Inter, sans-serif"
    >
      31
    </text>
  </svg>
);

export const SalesforceLogo = () => (
  <svg viewBox="0 0 48 48" width="52" height="52" aria-hidden="true">
    <g fill="#00A1E0">
      <circle cx="18" cy="28" r="7.5" />
      <circle cx="27" cy="22" r="9.5" />
      <circle cx="35" cy="28" r="6.8" />
      <rect x="18" y="27.5" width="17" height="7.5" rx="3.75" />
    </g>
  </svg>
);

export const HubSpotLogo = () => (
  <svg viewBox="0 0 48 48" width="52" height="52" aria-hidden="true">
    <g stroke="#FF7A59" strokeWidth="2.8" fill="none" strokeLinecap="round">
      <circle cx="21" cy="30.5" r="7.5" />
      <path d="M34 16.5v7.8M33 25.5l-5.2 2.6" />
    </g>
    <circle cx="34" cy="13.5" r="3.6" fill="#FF7A59" />
    <circle cx="21" cy="30.5" r="2.8" fill="#FF7A59" />
  </svg>
);

export const FreshworksLogo = () => (
  <svg viewBox="0 0 48 48" width="52" height="52" aria-hidden="true">
    <defs>
      <clipPath id="freshworks-mark">
        <rect x="9" y="9" width="30" height="30" rx="9" />
      </clipPath>
    </defs>
    <g clipPath="url(#freshworks-mark)">
      <rect x="9" y="9" width="15" height="15" fill="#25C16F" />
      <rect x="24" y="9" width="15" height="15" fill="#FFB400" />
      <rect x="9" y="24" width="15" height="15" fill="#2E7DF7" />
      <rect x="24" y="24" width="15" height="15" fill="#FF4D4D" />
    </g>
  </svg>
);

export const ZendeskLogo = () => (
  <svg viewBox="0 0 48 48" width="52" height="52" aria-hidden="true">
    <circle cx="24" cy="24" r="20" fill="#03363D" />
    <path
      d="M17 18.5h14L17 29.5h14"
      fill="none"
      stroke="#fff"
      strokeWidth="3.1"
      strokeLinejoin="round"
      strokeLinecap="round"
    />
  </svg>
);

export const HeadsetIcon = () => (
  <svg
    viewBox="0 0 24 24"
    width="18"
    height="18"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.9"
  >
    <path d="M4 14v-2a8 8 0 0 1 16 0v2" strokeLinecap="round" />
    <rect x="2.5" y="13.5" width="4" height="6" rx="2" />
    <rect x="17.5" y="13.5" width="4" height="6" rx="2" />
    <path d="M20 19.5v.5a2.5 2.5 0 0 1-2.5 2.5H13" strokeLinecap="round" />
  </svg>
);

export const PipedriveLogo = () => (
  <svg viewBox="0 0 48 48" width="52" height="52" aria-hidden="true">
    <circle cx="24" cy="24" r="20" fill="#017737" />
    <path
      d="M20 38V16.5c1.9-1.3 4.3-2 6.7-2 5.2 0 8.8 3.7 8.8 9.2s-3.6 9.4-8.6 9.4c-2.2 0-4-.7-5.2-1.8"
      fill="none"
      stroke="#fff"
      strokeWidth="3.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ZohoLogo = () => (
  <svg viewBox="0 0 48 48" width="52" height="52" aria-hidden="true">
    <rect x="8" y="8" width="32" height="32" rx="8" fill="#E42527" />
    <path
      d="M17 18h14l-14 12h14"
      fill="none"
      stroke="#fff"
      strokeWidth="3.2"
      strokeLinejoin="round"
      strokeLinecap="round"
    />
  </svg>
);

export const GoHighLevelLogo = () => (
  <svg viewBox="0 0 48 48" width="52" height="52" aria-hidden="true">
    <rect x="8" y="8" width="32" height="32" rx="9" fill="#182B4B" />
    <path
      d="M16.5 31V17M16.5 24h7M23.5 17v14"
      fill="none"
      stroke="#3FC8A9"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <path
      d="M28.5 17v14h5.5"
      fill="none"
      stroke="#fff"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MicrosoftLogo = () => (
  <svg viewBox="0 0 48 48" width="52" height="52" aria-hidden="true">
    <rect x="10" y="10" width="13" height="13" fill="#F25022" />
    <rect x="25" y="10" width="13" height="13" fill="#7FBA00" />
    <rect x="10" y="25" width="13" height="13" fill="#00A4EF" />
    <rect x="25" y="25" width="13" height="13" fill="#FFB900" />
  </svg>
);

export const IntercomLogo = () => (
  <svg viewBox="0 0 48 48" width="52" height="52" aria-hidden="true">
    <rect x="8" y="8" width="32" height="32" rx="8" fill="#1F8DED" />
    <g stroke="#fff" strokeWidth="2.6" strokeLinecap="round">
      <path d="M16 19v9M20.7 17v13M25.3 17v13M30 19v9" />
      <path d="M16.5 32.5c4.6 2 10.4 2 15 0" fill="none" />
    </g>
  </svg>
);
